import { fetch } from '@/utils/http'

export default {
  //CA列表
  getCaList: params => fetch('get', '/cbaas-service/v1/cert/queryCaEntityList', params),
  // 删除CA服务
  deleteCa: params => fetch('delete', '/cbaas-service/v1/cert/deleteCaEntity', params)
}
